module.exports = __webpack_public_path__ + "img/26.3412e4bc.png";